<div class="app-wrapper">
    <router-outlet ></router-outlet>
</div>

